import { toast } from "extensions/toast";
import { update } from "lodash-es";

import { Qualifiers } from "common/components/queryBuilder/qualifiers";
import { store } from "common/store";

import { admin } from "common/config/api";
import { request } from "common/components/request";

import { pazienHistory } from "common/components/pazienHistory";

const updateURL = () => {
    const state = store.getState();
    pazienHistory.navigateWithParams(`administrator/requests/${state.requests.section}/${window.encodeURIComponent(state.requests.qualifiers)}`, { trigger: false, replace: false });
};

export const REQUESTS_SET_STATE_FROM_URL = function(data) {
    store.dispatch({
        type: "REQUESTS_SET_STATE_FROM_URL",
        data
    });
    
    // And immediately update the url with any defaults
    updateURL();
};

export function UPDATE_FILTERS({ qualifiers }) {
    return (dispatch, getState) => {
        dispatch({
            type: "REQUESTS_UPDATE_FILTERS",
            qualifiers: qualifiers.toString()
        });
        
        updateURL();
    };
}

export function FETCH_TYPEAHEAD() {
    return (dispatch, getState) => {
        if (Object.keys(getState().requests.typeahead).length > 0) return Promise.resolve();
        
        return request("/admin/requests/dimensions/uri_template").then((data) => {
            dispatch({
                type: "REQUESTS_SET_TYPEAHEAD_DATA",
                data: {
                    uri_template: data
                }
            });
        }).catch((error) => {
            toast.error("There was an error fetching typeahead values for the requests filter bar");
        });
    };
}

export function ADD_FILTER({ filter }) {
    return (dispatch, getState) => {
        dispatch({
            type: "REQUESTS_UPDATE_FILTERS",
            qualifiers: `${getState().requests.qualifiers} ${filter}`.trim()
        });
        
        updateURL();
    };
}

export function TOGGLE_REQUEST_DETAILS() {
    return (dispatch, getState) => {
        dispatch({
            type: "TOGGLE_REQUEST_DETAILS"
        });
    
        updateURL();
    };
}

export function UPDATE_REQUESTS_ACTIVE_TAB(section, structure) {
    return (dispatch, getState) => {
        dispatch({
            type: "UPDATE_REQUESTS_ACTIVE_TAB",
            section,
            structure
        });
        
        updateURL();
    };
}

export const fetchRequestDetails = ({ queryKey: [_key, args] }) => fetchRequests({ queryKey: [_key, { ...args, details: true }] });

export const fetchRequests = ({
    queryKey: [
        _key,
        {
            details = false,
            pivots = [],
            qualifiers,
            date_range: {
                startDate,
                endDate
            },
            page = null,
            limit = 100
        }
    ]
}) => {
    const q = new Qualifiers({ value: qualifiers });

    const reqData = {
        q: q.toString(),
        start: startDate,
        end: endDate,
        pivots,
        ...page && { page, limit }
    };

    return request(details ? admin.requests_details : admin.requests, { data: reqData }).then(
        (data) => (details ? data : data.map((d) => update(d, "average_request_time", (n) => n * 1000)))
    );
};
